'use strict';

var _Constants = require('common/Constants');

var _Constants2 = _interopRequireDefault(_Constants);

require('styles/theme.scss');

require('styles/theme.scss.liquid');

require('@shopify/polyfills/baseline');

require('promise-polyfill/src/polyfill');

require('lazysizes');

require('jquery-countdown');

var _pubsubJs = require('pubsub-js');

var _pubsubJs2 = _interopRequireDefault(_pubsubJs);

var _themeA11y = require('@shopify/theme-a11y');

var _Global = require('common/Global');

var _CartControls = require('components/CartControls');

var _CartControls2 = _interopRequireDefault(_CartControls);

var _InlineCart = require('components/InlineCart');

var _InlineCart2 = _interopRequireDefault(_InlineCart);

var _QuantitySelect = require('components/QuantitySelect');

var _QuantitySelect2 = _interopRequireDefault(_QuantitySelect);

var _Toggle = require('components/Toggle');

var _Toggle2 = _interopRequireDefault(_Toggle);

var _Overlay = require('components/Overlay');

var _Overlay2 = _interopRequireDefault(_Overlay);

var _Scroll = require('components/Scroll');

var _Scroll2 = _interopRequireDefault(_Scroll);

var _VariantId = require('components/VariantId');

var _VariantId2 = _interopRequireDefault(_VariantId);

var _Price = require('components/Price');

var _Price2 = _interopRequireDefault(_Price);

var _ShopifySectionEvents = require('common/ShopifySectionEvents');

var _ShopifySectionEvents2 = _interopRequireDefault(_ShopifySectionEvents);

var _Swell = require('components/Swell');

var _Accordion = require('components/Accordion');

var _Accordion2 = _interopRequireDefault(_Accordion);

var _MegaMenu = require('components/MegaMenu');

var _MegaMenu2 = _interopRequireDefault(_MegaMenu);

var _ResponsiveBackgrounds = require('components/ResponsiveBackgrounds');

var _ResponsiveBackgrounds2 = _interopRequireDefault(_ResponsiveBackgrounds);

var _MobileMenu = require('components/MobileMenu');

var _MobileMenu2 = _interopRequireDefault(_MobileMenu);

var _SearchDrawer = require('components/SearchDrawer');

var _SearchDrawer2 = _interopRequireDefault(_SearchDrawer);

var _SocialSharing = require('components/SocialSharing');

var _SocialSharing2 = _interopRequireDefault(_SocialSharing);

var _EmailSignup = require('components/EmailSignup');

var _EmailSignup2 = _interopRequireDefault(_EmailSignup);

var _ProductCarousel = require('components/ProductCarousel');

var _ProductCarousel2 = _interopRequireDefault(_ProductCarousel);

var _ProductAvailability = require('components/ProductAvailability');

var _ProductAvailability2 = _interopRequireDefault(_ProductAvailability);

var _InlineCartRecs = require('components/InlineCartRecs');

var _InlineCartRecs2 = _interopRequireDefault(_InlineCartRecs);

var _Account = require('components/Account');

var _Account2 = _interopRequireDefault(_Account);

var _AccountNav = require('components/AccountNav');

var _AccountNav2 = _interopRequireDefault(_AccountNav);

var _Faq = require('components/Faq');

var _Faq2 = _interopRequireDefault(_Faq);

var _Flow = require('components/Flow');

var _Flow2 = _interopRequireDefault(_Flow);

var _DynamicYield = require('components/DynamicYield');

var _DynamicYield2 = _interopRequireDefault(_DynamicYield);

var _ErrorTracking = require('components/ErrorTracking');

var _ErrorTracking2 = _interopRequireDefault(_ErrorTracking);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// Things that can go right away


// Need to attach Cookies to window for third parties like snippets/third_parties/Flow/FlowCustom.liquid


// Vendor
(0, _themeA11y.focusHash)();
(0, _themeA11y.bindInPageLinks)();

State.cacheCart();

State.initSubscribers();
_CartControls2.default.initSubscribers();
_InlineCart2.default.initSubscribers();
_QuantitySelect2.default.initSubscribers();
_Toggle2.default.initSubscribers();
_Overlay2.default.initSubscribers();

_VariantId2.default.initSubscribers();
_Price2.default.initSubscribers();
_Flow2.default.initSubscribers();
_DynamicYield2.default.initSubscribers();
_ErrorTracking2.default.initSubscribers();

_Flow2.default.init();

// Things that need DOM Ready
document.addEventListener('DOMContentLoaded', function () {
  (0, _Global.GlobalFunction)();
  (0, _ShopifySectionEvents.addSectionContainerClasses)();

  // PRG
  State.init();
  _Price2.default.init();
  _InlineCart2.default.init();

  _CartControls2.default.bindActions();
  _InlineCart2.default.bindActions();
  _Overlay2.default.bindActions();
  _Scroll2.default.bindActions();
  _QuantitySelect2.default.bindActions();
  _Toggle2.default.bindActions();
  _Price2.default.bindActions();

  // BVA
  _MegaMenu2.default.bindActions();
  _ResponsiveBackgrounds2.default.init();
  _MobileMenu2.default.init();
  _SearchDrawer2.default.init();
  _InlineCartRecs2.default.init();
  _EmailSignup2.default.init();
  _Swell.SwellRewards.init();
  _Swell.SwellOverwrite.init();
  _Swell.SwellRewardsMVMTInsider.init();
  _ProductCarousel2.default.init();
  _Accordion2.default.bindActions();
  _SocialSharing2.default.init();
  _ProductAvailability2.default.init();
  _Faq2.default.bindActions();
  _Faq2.default.init();

  if (window.prg.template.path && window.prg.template.path.includes('customers')) {
    _Account2.default.bindActions();
    _Account2.default.init();
    _AccountNav2.default.bindActions();
    _AccountNav2.default.init();
  }
});

// Things that need window load
window.addEventListener('load', function () {});

// Dev / Debug
_ShopifySectionEvents2.default.bind();
_pubsubJs2.default.immediateExceptions = true;

if (!window.prg.theme.name.toLowerCase().includes('production')) {
  var topics = [
    // 'PRG',
    // prg.animationEnd,
    // prg.animationStart,
    // prg.addToCart,
    // prg.updateCart,
    // prg.removeFromCart,
    // prg.batchRequests,
    // prg.enqueueRequest,
    // prg.dequeueRequest,
    // prg.requestError,
    // prg.requestSuccess,
    // prg.openInlineCart,
    // prg.closeInlineCart,
    // prg.toggleInlineCart,
    // prg.updateInlineCartUIStart,
    // prg.updateInlineCartUIError,
    // prg.optionValueChange,
    // prg.updatePrice,
    // prg.updateProductPrice,
    // prg.toggle,
    // prg.updateVariant,
    // prg.updateVariantId,
    // prg.hideModal,
    // prg.showModal,
    // prg.openModal,
    // prg.closeModal,
    // prg.toggleModal,
    // prg.showOverlay,
    // prg.hideOverlay,
    // prg.openQuickshop,
    // prg.closeQuickshop,
    // prg.toggleQuickshop,
    // prg.updateSliderSlide,
    // prg.updateContainerSliders,
    // prg.state,
    // prg.initState,
    // prg.createState,
    // prg.updateState,
    // prg.deleteState,
    // prg.updateQuantity,
    // prg.variantChange,
    // prg.updateVariantMap,
    // prg.updateOptionValue,
    // prg.updateProductQuantity,
    // prg.updateInventoryState,
    // prg.allProductContainersInit,
    // prg.allContainersInit,
    // prg.updateCartState,
    // prg.updateLineItem,
    // prg.updateLineItemQuantity,
    // prg.flowReady,
    // prg.flowLocalized,
    // prg.error,
  ];

  topics.forEach(function (topic) {
    return _pubsubJs2.default.subscribe(topic, function (message, data) {
      return console.log(message, data);
    });
  });
}

// HMR
// if (module.hot) {
//   module.hot.accept();
// }

// if (module.hot) {
//   module.hot.dispose(() => {  // reset/undo the behavior/side effect that as possibly enabled/enacted

//   });
// }